import Vue from 'vue'
import { router } from '@src/routes'

export default {
  namespaced: true,
  state: {
    items: {},
  },
  getters: {
    items(state) {
      return state.items
    },
  },
  mutations: {
    addItems(state, data) {
      state.items = data
    },
  },
  actions: {
    loadItems(store, to) {
      if (process.env.NODE_ENV === 'production') {
        return new Promise((resolve, reject) => {
          let url = 'meta?url='
          Vue.http
            .get(url + to.replace(router.history.base, ''))
            .then(response => response.json())
            .then(data => {
              store.commit('addItems', data)
              resolve()
            })
        })
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/legacy/store/modules/meta.js